import { constants } from "@newsela/angelou";

const { colors } = constants;

const darkBlue = colors.ui.core[700];
const extraLightGrey = colors.ui.neutral[25];

export const listCss = {
  padding: 0,
  margin: 0,
};

export const listItemCss = {
  listStyle: "none",
  width: "100%",
  margin: 0,
};

export const listItemButtonCss = {
  width: "60px",
  backgroundColor: colors.ui.white[700],
  color: darkBlue,
  borderRadius: 0,
  margin: "2px",

  "&:hover": {
    backgroundColor: extraLightGrey,
  },
};
